import { Group, Input } from "@mantine/core";
import type { CountryCode } from "libphonenumber-js";
import { usePhoneInput } from "react-international-phone";
import { CountrySelect } from "./CountrySelect/CountrySelect";
import styles from "./PhoneInput.module.css";

interface PhoneInputProps {
    value: string;
    onChange: (phone: string) => void;
    defaultCountry?: CountryCode;
    countrySelectDisabled?: boolean;
    clientEnabledCountries?: CountryCode[] | undefined;
}

export function PhoneInput({
    value,
    onChange,
    defaultCountry = "US",
    countrySelectDisabled = false,
    clientEnabledCountries,
}: PhoneInputProps) {
    const phoneInput = usePhoneInput({
        defaultCountry,
        value,
        forceDialCode: !countrySelectDisabled,
        onChange: ({ phone }) => {
            onChange(phone);
        },
    });

    return (
        <Group gap="xs" wrap="nowrap" w="100%">
            {!countrySelectDisabled && (
                <CountrySelect
                    setCountry={phoneInput.setCountry}
                    clientEnabledCountries={clientEnabledCountries}
                    defaultCountry={defaultCountry}
                />
            )}
            <Input
                className={styles.input}
                onChange={phoneInput.handlePhoneValueChange}
                value={phoneInput.inputValue}
            />
        </Group>
    );
}
